import { ContractModel, ContractCategory } from "src/app/v2/pages/contracts/models/contracts.models";
import { MockScenario } from "../mock-scenario";

const dnbPensionMockContract: ContractModel = {
  id: "DNB-001",
  name: "DNB Pensjonsforsikring",
  subtitle: "Fra DNB",
  detailsLink: null,
  type: ContractCategory.Employer,
  contractOptions: { isMoved: false, isPaidUp: false },
  totalBalance: 450000,
  totalReturn: 35000,
  inTransit: false,
};

const klpMockContract: ContractModel = {
  id: "KLP-002",
  name: "KLP Fellespensjon",
  subtitle: "Fra KLP",
  detailsLink: null,
  type: ContractCategory.Employer,
  contractOptions: { isMoved: false, isPaidUp: false },
  totalBalance: null,
  totalReturn: 28000,
  inTransit: false,
};

export const generateMockContractsFromExternal = (
  scenario: MockScenario,
): {
  payload: ContractModel[];
} => {
  return {
    payload: scenario.externalContracts ? [dnbPensionMockContract, klpMockContract] : [],
  };
};
